<igx-grid #gridExpInsXConcepto [data]="conceptos" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
          [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowEditable]="false"
          [primaryKey]="'IdCatalogo'" [sortingOptions]="sortingOptions" [moving]="true">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral [mostrarChkInicio]="true" (enterPalabra)="filterInput($event)"
                          (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid [arrayDatosAVer]="[0, 1, 2, 6]"
                             (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Tipo" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_TIPO' | translate}}" [dataType]="'number'"
              width="100px" [sortable]="true" [resizable]="true" />
  <igx-column field="Codigo" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_CODIGO' | translate}}" [dataType]="'string'"
              width="160px" [sortable]="true" [resizable]="true" />
  <igx-column field="DescripcionLarga" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_DESCRIPCION_LARGA' | translate}}"
              [dataType]="'string'" minWidth="400px" [sortable]="true" [resizable]="true" [hasSummary]="true"
              [summaries]="'filasSummary' | summaryPipeNeo" />
  <igx-column field="Unidad" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_UNIDAD' | translate}}" [dataType]="'string'"
              width="100px" [sortable]="true" [resizable]="true" />
  <igx-column field="Cantidad" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_CANT' | translate}}" [dataType]="'number'"
              width="120px" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecExpIns" />
  <igx-column field="CostoMoneda1" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_COSTO_M1' | translate}}"
              [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true" [pipeArgs]="formatColMoneda2Dec" />
  <igx-column field="CostoMoneda2" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_COSTO_M2' | translate}}"
              [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true" [hidden]="true"
              [pipeArgs]="formatColMoneda2Dec" />
  <igx-column field="ImporteMoneda1" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_IMPORTE_M1' | translate}}"
              [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true" [hasSummary]="true"
              [summaries]="'monedaSummary' | summaryPipeNeo" [pipeArgs]="formatColMoneda2Dec" />
  <igx-column field="ImporteMoneda2" header="{{'GRIDS.EXP_INSUMO_CONCEPTO.COL_IMPORTE_M2' | translate}}"
              [dataType]="'currency'" width="150px" [sortable]="true" [resizable]="true" [hasSummary]="true"
              [hidden]="true" [summaries]="'monedaSummary' | summaryPipeNeo" [pipeArgs]="formatColMoneda2Dec" />
  <igx-column field="Porcentaje1" header="% 1" [dataType]="'percent'" width="120px" [sortable]="true" [resizable]="true"
              [pipeArgs]="formatPorcentaje2Dec" [hasSummary]="true" [summaries]="'porcentajeSummary' | summaryPipeNeo" />
  <igx-column field="Porcentaje2" header="% 2" [dataType]="'percent'" width="120px" [sortable]="true" [resizable]="true"
              [hidden]="true" [pipeArgs]="formatPorcentaje2Dec" [hasSummary]="true" [summaries]="'porcentajeSummary' | summaryPipeNeo" />
</igx-grid>
